export default "__VITE_ASSET__MKwQ76L7__"